import React from 'react';
import PropTypes from 'prop-types';
import { map, omit, pick, upperFirst } from 'lodash';
import classnames from 'classnames';
import { compose, withProps, defaultProps } from 'recompose';


import { H4 } from 'components/core/Typography';
import Amenity from './Amenity';
import { withAmenities } from './utils';

import './facilityGroupedAmenityList.scss';

const PRIORITY_AMENITIES = ['billing', 'access', 'administration'];

export const enhance = compose(
	defaultProps({ hasVehicles: true }),
	withProps(({ groupedAmenities, searchType, hasVehicles }) => {
		const priorityAmenities = [...PRIORITY_AMENITIES];
		if (searchType === 'vehicle') {
			priorityAmenities.unshift('vehicle');
		}

		let amenityGroups = {
			...(withAmenities(pick(groupedAmenities, priorityAmenities))),
			...(withAmenities(omit(groupedAmenities, priorityAmenities)))
		};

		if (!hasVehicles) {
			amenityGroups = omit(amenityGroups, 'vehicle');
		}
		return {
			amenityGroups
		};
	}),
);

export function FacilityGroupedAmenityList({
	className,
	amenityGroups
}) {
	return (
		<div className={classnames(className, 'facility-grouped-amenities')}>
			<div className="amenity-groupings">
				{map(amenityGroups, (amenityGroup, key) => (
					<div className="amenity-group" key={key}>
						<H4 eyebrow>
							{amenityGroup.label || upperFirst(key)}
						</H4>
						{map(amenityGroup.items, (amenity) => (
							<Amenity key={amenity.label} amenity={amenity} />
						))}
					</div>
				))}
			</div>
		</div>
	);
}

FacilityGroupedAmenityList.propTypes = {
	className: PropTypes.string,
	amenityGroups: PropTypes.objectOf(PropTypes.shape({
		label: PropTypes.string,
		items: PropTypes.object
	}))
};

export default enhance(FacilityGroupedAmenityList);
